module.exports = __webpack_public_path__ + "images/icons/agents.522975b729192a4a6c5d0e0e59552e5c.png";